import {
  type PropsWithChildren, useEffect,
} from 'react';

// TODO: When we adopt React 19, remove this component and replace all of its usages with simply <title>.
export const Title = ({ children }: PropsWithChildren) => {
  useEffect(() => {
    if (typeof children === 'string') {
      document.title = children;
    }
    else if (children) {
      throw new Error('[Title]: Given children are not a string. Please use a string as children.');
    }
  }, [children]);

  return null;
};
